import { render, staticRenderFns } from "./GoogleSuburbAutocomplete.vue?vue&type=template&id=96b09816"
import script from "./GoogleSuburbAutocomplete.vue?vue&type=script&lang=js"
export * from "./GoogleSuburbAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports